import { apiList, apiGet, apiCreate, apiUpdate, apiDelete } from './apiClient';

export const getCustomers = async (_params?: any) => apiList('customers');
export const getCustomerById = async (id: number | string) => apiGet('customers', id);
export const createCustomer = async (data: any) => apiCreate('customers', data);
export const updateCustomer = async (id: number | string, data: any) => apiUpdate('customers', id, data);
export const deleteCustomer = async (id: number | string) => apiDelete('customers', id);
